import { Link, LinkIconPosition, LinkProps } from "@amzn/stencil-react-components/link";
import IconChevronRightSmall from "@amzn/stencil-react-icons/icons/icon-chevron-right-small";
import React, { FC, MouseEvent } from "react";
import { useHistory } from "react-router-dom";

export interface InternalLinkProps extends Omit<LinkProps, "href"> {
  to: string;
}

const isPlainLeftClick = (event: MouseEvent<HTMLAnchorElement>): boolean =>
  event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;

/** A Stencil link to a website path that navigates through the router instead of reloading the page. */
export const InternalLink: FC<InternalLinkProps> = ({
  to,
  onClick,
  children,
  icon = <IconChevronRightSmall aria-hidden={true} />,
  iconPosition = LinkIconPosition.Trailing,
  ...linkProps
}) => {
  const history = useHistory();

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    onClick?.(event);
    if (event.defaultPrevented || !isPlainLeftClick(event)) {
      return;
    }
    event.preventDefault();
    history.push(to);
  };

  return (
    <Link
      {...linkProps}
      href={history.createHref({ pathname: to })}
      onClick={handleClick}
      icon={icon}
      iconPosition={iconPosition}
    >
      {children}
    </Link>
  );
};
